
export default class APIProxy {

  authHeaders = {
    'token': '',
    'email': '',
    'userId': '',
    'userType': '',
    'teamId':1,
    'managerId':1,
  };

  updateCredentialHeaders(credentials) {
    this.authHeaders = {
      'token': credentials.token,
      'email': credentials.email,
      'userId':credentials.userId,
      // 'userType':credentials.user_type,
      'userType':'admin',
      'teamId':1,
      'managerId':1
    }
  }

  get(url, action) {
    fetch(url, {
      headers: {
        ...this.authHeaders
      },
    })
      .then(response => response.json())
      .then(json => {
        action(json);
      });
  }

  post(url, bodyParams, action) {
    fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        ...this.authHeaders
      },
      body: JSON.stringify(bodyParams)
    })
      .then(response => response.json())
      .then(json => {
        action(json);
      });
  }

  asyncPost(url, bodyParams, headers = {}) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'access-control-allow-origin': '*',
        ...this.authHeaders,
        ...headers
     
      },
      body: JSON.stringify(bodyParams)
    });
  }

  asyncPatch(url, bodyParams, headers = {}) {
    return fetch(url, {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'access-control-allow-origin': '*',
        ...this.authHeaders,
        ...headers
      },
      body: JSON.stringify(bodyParams)
    });
  }

  asyncDelete(url, bodyParams) {
    return fetch(url, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'access-control-allow-origin': '*',
        ...this.authHeaders
      },
      body: JSON.stringify(bodyParams)
    });
  }

  getAsync(url, headers = {}) {
    return fetch(url, {
      headers: {
        ...this.authHeaders,
        ...headers
      }
    },
    );
  }
  getGeneric(url, headers = {}) {
    return fetch(url, {
      headers: {
        'Content-Type':'application/json',
        ...this.authHeaders,
        ...headers
      }
    }
    );
  }
}
